import { render, staticRenderFns } from "./SidebarAdditionalCriteria.vue?vue&type=template&id=2b9cabfb&"
import script from "./SidebarAdditionalCriteria.vue?vue&type=script&lang=js&"
export * from "./SidebarAdditionalCriteria.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAdditionalCriteria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports